<template>
    <trax-ui-card background-color="secondary" v-show="visible">

        <p class="text-center mt-3 mb-0">{{ lang.polaris.procedure.procedure_has_been }}</p>
        <h2 class="text-center mb-3">{{ lang.polaris.procedure.closed }}</h2>

    </trax-ui-card>
</template>

<script>
    export default {
    
        props: {
            id: {default: 'enac-procedure-atp-daf-edit'},
            visibleWhen: null,
            visibleWhenOr: null
        },

        data: function() {
            return {
                lang: lang,
                visible: false,
                bus: this.$bus
            }
        },
        
        created: function() {
            this.bus.$on(this.id+'-data', this.setData);
            this.bus.$on(this.id+'-updated', this.setData);
        },

        methods: {

            setData(procedure) {
                this.visible = procedure.data[this.visibleWhen]
                    || (this.visibleWhenOr && procedure.data[this.visibleWhenOr]);
            }
        }
    }
</script>
